import React from 'react';
import { useTranslation } from 'react-i18next';
import { IResourceSection } from '../../models/IStatistic';
import StatsHorizontalChart from './StatsHorizontalChart';
import { STATISTICS_STATUS_COLOR_ENUM } from '../../api_enums/STATISTICS_STATUS_ENUM';

interface Prop {
  chartData: IResourceSection[];
}

function StatsRequestedResources({ chartData }: Prop) {
  const { t } = useTranslation();

  const transformQueryResult = (queryResult: IResourceSection[] = []) => {
    const sections: string[] = [];
    const statusesSet = new Set<string>();
    const sectionStatusMap: Record<string, Record<string, number>> = {};
    queryResult?.forEach(({ status, section_info, count }) => {
      const sectionName = section_info?.name || 'Unknown Section';

      if (!sections.includes(sectionName)) sections.push(sectionName);
      statusesSet.add(status);

      sectionStatusMap[sectionName] = sectionStatusMap[sectionName] || {};

      sectionStatusMap[sectionName][status] =
        (sectionStatusMap[sectionName][status] || 0) + count;
    });

    const statuses = Array.from(statusesSet);

    const datasetsStatus = statuses.map((status) => ({
      label: t(`StatisticsHelp.${status}`) || 'Unknown Status',
      data: sections.map((section) => sectionStatusMap[section]?.[status] || 0),
      backgroundColor: STATISTICS_STATUS_COLOR_ENUM[status],
    }));

    return {
      sections,
      statuses,
      datasetsStatus,
    };
  };

  const resourceSectionData = transformQueryResult(chartData);

  /*
   * X-Axis: Resources
   * Y-Axis: Sections
   * The plot is the stacked Bar chart
   */
  const dataResourcePerSection = {
    labels: resourceSectionData.sections,
    datasets: resourceSectionData.datasetsStatus,
  };

  return (
    <StatsHorizontalChart
      description={t('StatisticsHelp.ResourcePerSection')}
      editingDescription={t('StatisticsHelp.ResourcePerSectionEditing')}
      title={t('StatsControlsBarchart.RequestedResources')}
      data={dataResourcePerSection}
      stacked={true}
    />
  );
}

export default StatsRequestedResources;
